import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PropTypes from "prop-types";
import Header2 from "../components/header/Header2";
import Footer from "../components/footer";
import Breadcrumb from "../components/breadcrumb";
import BlogSec1 from "../components/blog/BlogSec1";
import dataBlog from "../assets/fakeData/dataBlog";
import Gotop from "../components/gotop";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import Header03 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader"
import httpService from "../services/httpService";
import { getToken, getFromStorage, setToken, setToStorage } from "../services/authService"

const HomeNews = () => {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  // categories for homepage news
  const [topNewsData, setTopNewsData] = useState([]);
  const [LIUData, setLIUData] = useState([]);
  const [ILRData, setILRData] = useState([]);
  const [countriesData, setCountriesData] = useState([]);
  const [familyClassData, setFamilyClassData] = useState([]);
  const [UKCitiesData, setUKCitiesData] = useState([]);
  const [UKWorkData, setUKWorkData] = useState([]);
  const [UKStudyData, setUKStudyData] = useState([]);
  const [UKVisitData, setUKVisitData] = useState([]);
  const [UKSettlingData, setUKSettlingData] = useState([]);
  const [sponsorshipJobs, setUKSponsorshipJobs] = useState([]);
  const [UKBusiness, setUKBusiness] = useState([]);
  const [UKCommunityData, setUKCommunityData] = useState([]);

  const [username, setUsername] = useState("");
  const [userToken, setUserToken] = useState("");

  const [latestNews, setLatestNews] = useState([]);
  const [loadLatestNews, setLoaderLatestNews] = useState(true);

  const [loader, setLoader] = useState(true);


  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const getLatestNews = async () => {
    try {
      const res = await httpService.get("news/latest/news");
      setLatestNews(res.data.data);
      setLoaderLatestNews(false);
    } catch (error) { }
  };

  const getNews = async () => {
    try {
      const res = await httpService.get("news");

      const liu = [];
      const ilr = [];
      const countries = [];
      const family = [];
      const citizenship = [];
      const work = [];
      const study = [];
      const visit = [];
      const settling = [];
      const sponsorshipJobs = [];
      const business = [];
      const communityData = [];

      res.data.data.forEach(element => {
        switch (element.category) {
          case "life-in-the-uk":
            liu.push(element);
            break;
          case "indefinite-leave-to-remain-ilr":
            ilr.push(element);
            break;
          case "countries-immigration":
            countries.push(element);
            break;
          case "family-sponsorship":
            family.push(element);
            break;
          case "citizenship":
            citizenship.push(element);
            break;
          case "work":
            work.push(element);
            break;
          case "study":
            study.push(element);
            break;
          case "visit":
            visit.push(element);
            break;
          case "settling-in-the-uk":
            settling.push(element);
            break;
          case "sponsorship-jobs":
            sponsorshipJobs.push(element);
            break;
          case "business":
            business.push(element);
            break;
          case "community":
            communityData.push(element);
            break;
          default:
            break;
        }
      });

      setLIUData(liu);
      setILRData(ilr);
      setCountriesData(countries);
      setFamilyClassData(family);
      setUKCitiesData(citizenship);
      setUKWorkData(work);
      setUKStudyData(study);
      setUKVisitData(visit);
      setUKSettlingData(settling);
      setUKSponsorshipJobs(sponsorshipJobs);
      setUKBusiness(business);
      setUKCommunityData(communityData);
      setLoader(false);
    } catch (err) { }
  };

  const token = async () => {

    const userToken = getToken();

    if (!userToken) return;

    const username = getFromStorage('username');

    setUsername(username);
    setUserToken(userToken);
  }

  useEffect(() => {
    token()
    getNews();
    getLatestNews();
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>UKICNEWS - Homepage | Latest UK Immigration News</title>
          <meta
            name="description"
            content="Stay updated with the latest UK immigration news, visa changes, sponsorship jobs, and clear policy explanation for Business, Family Sponsorship, study, work, visit, ILR and more. UKICNEWS delivers trusted and timely immigration updates."
          />
          <link rel="canonical" href="https://www.ukicnews.com/" />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="UKICNEWS | Latest UK Immigration News" />
          <meta
            property="og:description"
            content="Get reliable UK immigration updates, visa news, and sponsorship job opportunities."
          />
          <meta property="og:url" content="https://www.ukicnews.com/" />
          <meta property="og:image" content="https://www.ukicnews.com/preview.png" />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="UKICNEWS | UK Immigration Updates" />
          <meta
            name="twitter:description"
            content="Stay updated with UK immigration rules and sponsorship jobs."
          />
          <meta name="twitter:image" content="https://www.ukicnews.com/preview.png" />
        </Helmet>
      </HelmetProvider>

      <MobileHeader handleMobile={handleMobile} />
      <Header03 clname="act1" handleMobile={handleMobile} userToken={userToken} username={username} />

      <BlogSec1
        handleMobile={handleMobile}
        data={dataBlog}
        topNewsData={topNewsData}
        LIUData={LIUData}
        ILRData={ILRData}
        countriesData={countriesData}
        familyClassData={familyClassData}
        UKCitiesData={UKCitiesData}
        UKWorkData={UKWorkData}
        UKStudyData={UKStudyData}
        UKVisitData={UKVisitData}
        UKSettlingData={UKSettlingData}
        latestNews={latestNews}
        UKCommunityData={UKCommunityData}
        loadLatestNews={loadLatestNews}
        loader={loader}
      />
      <Footer />
      <Gotop />
    </>
  );
}

export default HomeNews;
